module.exports = __webpack_public_path__ + "static/media/albumCover.b849712f.JPG";